// extracted by mini-css-extract-plugin
export default {"header":"Permission_header__2l02G"};